export const DEFAULT_TRACKING_PARAMS = {
    depth: 1,
    type: "click",
    report: null,
    report_group: null,
    report_domain: "",
    analytics_domain: "",
    position_order: 1,
    is_dropdown_list: false,
    is_locked: undefined,
    tag: "none",
};
export const POSITION_FOR_TRACKING = 3;
